module.exports = __webpack_public_path__ + "img/3d-desktop_jp.c2083a9.jpg";